import { useCollection } from "@/hooks/useCollection";
import type { TeamMember } from "@/lib/types";

export default function Team() {
  const { items } = useCollection<TeamMember>("team_members");

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-sm font-semibold text-primary-600">
            Notre équipe
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Les visages derrière l'engagement
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Bénévoles et membres actifs, ils portent au quotidien les actions
            de Humanity59 sur le terrain.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((member, index) => (
            <div
              key={member.id || member.name || index}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="w-full aspect-[4/5] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  title={`${member.name} — Humanity59`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {member.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-primary-600">
                  {member.role}
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}